import AccountHandler from "../../../../services/api/accountHandler";

export function changePassword(
  currentPassword,
  newPassword,
  confirmNewPassword
) {
  return AccountHandler.changePassword(
    currentPassword,
    newPassword,
    confirmNewPassword
  )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.warn("Error changing password...");
      throw err;
    });
}
